import React from "react";
import "./Header.css";
import { FaSearch } from "react-icons/fa";
import { FaDollyFlatbed } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaListUl } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
// import { Link, Outlet } from "react-router-dom";
import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
function Header() {

  const [headerFixed, setHeaderFixed] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (window.pageYOffset > 0) {
      setHeaderFixed(true);
    } else {
      setHeaderFixed(false);
    }
  };

  return (
    <>
      <div className="container-top">
        <h6 className="top-header">
         <marquee behavior="" direction=""> EXCHANGE FORM   FREE SHIPPING </marquee>
        </h6>
      </div>
      <div className=" menu1">
        <div className="row  ">
          <nav className={headerFixed ? "fixed-header" : ""}>
            <div className="navbar container-fluid main_menu"  >
              <span
                class="navbar-toggler m-0  p-0 nav"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasDarkNavbar"
                aria-controls="offcanvasDarkNavbar"
              > <p className="fs-6 m-1 ml-3 text-black">Menu</p>
                <FaListUl className="menuicon" />
              </span>
              <div
                className="offcanvas offcanvas-start text-bg-dark"
                tabindex="-1"
                id="offcanvasDarkNavbar"
                aria-labelledby="offcanvasDarkNavbarLabel"
              >
                <div className="offcanvas-header">
                  <h5 className="offcanvas-title" id="offcanvasDarkNavbarLabel">
                    <span className="fs-6 m-5">MENU</span>
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="offcanvas-body">
                  <ul className="navbar-nav justify-content-start light flex-grow-1 pe-3">
                    <Link to="/" className="nav-item links">Home </Link>
                    <Link to="/boski" className="nav-item links">Boski </Link>
                    <Link to="/washwear" className="nav-item links">Wash & Wear</Link>
                    <Link to="/kurta" className="nav-item links">Kurta </Link>
                    <Link to="/menshawal" className="nav-item links">Men Shawal</Link>
                    <Link to="/cotton" className="nav-item links">Cotton</Link>
                    <Link to="/karandi" className="nav-item links"> Karandi </Link>
                    <Link to="/contact" className="nav-item links">Contact Us</Link>
                    <Link to="/about" className="nav-item links">About Us </Link> 
                    {/* <li>Home</li>
                    <li>Boski</li>
                    <li>Home</li>
                    <li>Boski</li>
                    <li>Home</li>
                    <li>Boski</li> */}
                    <br />
                    <li>Country:</li>
                    <select className="nav-item dropdown">
                      <option value=" Pakistan">
                        <li className="dropdown-item">PAKISTAN</li>
                      </option>
                      <option value="India">
                        <li className="dropdown-item">INDIAN</li>
                      </option>
                      <option value="China">
                        <li className="dropdown-item">CHINA</li>
                      </option>
                    </select>

                    <li>Price</li>
                    <select className="nav-item dropdown">
                      <option value=" Pakistan">
                        <li className="dropdown-item">PKR</li>
                      </option>
                      <option value="India">
                        <li className="dropdown-item">USD</li>
                      </option>

                    </select>
                  </ul>
                  <br />

                  <br />
                  <br />
                  <br />
                  <br />
                  <form className="form_search" role="search">
                    <input
                      className="form-control m-1"
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                    />
                    <button className="btn btn-success m-1" type="submit">
                      Search
                    </button>
                  </form>
                </div>
              </div>
              <div className="logo">
                <Link to="/">
                <img
                  className="logo"
                  src="./image/logo.png"
                  alt=" please chose right logo"
                /></Link>
              </div>
              <div className="icon">
                <FaSearch className="h-search" />
                <FaDollyFlatbed className="h-dolly" />
                <FaFacebookF className="h-facebook" />
                <FaInstagramSquare className="h-instagram" />

                {/* <Link to="#" className="links"><FaSearch className="h-search" /> </Link>
                <Link to="/checkout" className="links"><FaDollyFlatbed className="h-dolly" /> </Link>
                <Link to="#" className="links"> <FaFacebookF className="h-facebook" /> </Link>
                <Link to="#" className="links"><FaInstagramSquare className="h-instagram" /></Link> */}

              </div>
            </div>
          </nav>
        </div>
      </div>

      {/* <Outlet /> */}
    </>
  );
}

export default Header;
